module.exports = __webpack_public_path__ + "static/media/monster-10.c4da332b.png";